// 素材相关接口
// 素材库
export function getMediaPageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/mediaNew/pageList',
    data
  })
}

// 新增
export function batchSaveMedia(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/mediaNew/batchSave',
    data
  })
}

// 编辑
export function saveMedia(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/mediaNew/addOrUpdate',
    data
  })
}

// 获取启用广告主有权限的广告位列表
export function getEnableSpace() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/getSpaceAll'
  })
}
// 获取素材分类列表
export function getMediaClass() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/mediaNew/getMediaClassList'
  })
}
// 获取媒体方列表
export function getChannelList(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/getAuthCableChannels',
    params
  })
}
// 获取提示语详情
export function getTipDetail(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adTempTips/data',
    data
  })
}
// 获取广告位对应的模板信息
export function getAdTempTips(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/adTempTips/spaceTemps',
    params
  })
}
// 获取广告位默认模板
export function getAdDefaultTip(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/adTempTips/dataDefaultTemp',
    params
  })
}
// 素材库详情
export function findMedia(params) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/mediaNew/adMediaDetail',
    params
  })
}
// 启用，暂停，删除映射状态
export function updateMediaStatus(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/mediaNew/operate',
    data
  })
}

// 获取交互事件模板
export function getTargetTemp(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adTargetTemp/dataList',
    data
  })
}

// 上传封面图
export function uploadMinIcon(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/file/imgUpload',
    data
  })
}

// 上传背景图
export function uploadBgImage(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/file/uploadBgImage',
    data
  })
}

// 上传弹窗引导图
export function uploadGuideIcon(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/file/guideIconUpload',
    data
  })
}

// 根据素材id list 查询
export function getMediaByIds(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/getMedia',
    data
  })
}
